import React, { CSSProperties } from 'react'
import { EventWrapperProps } from 'react-big-calendar'

import { AgendaEventModel } from './model'

export type AgendaEventProps<TEvent extends AgendaEventModel = AgendaEventModel> = Omit<
  EventWrapperProps<TEvent>,
  'style' | 'className'
>

export function AgendaEventWrapper<TEvent extends AgendaEventModel>(
  props: EventWrapperProps<AgendaEventModel> & { children: React.ComponentType<AgendaEventProps<TEvent>> }
) {
  const { style, className, children, ...rest } = convertEventComponentProps(props)
  return (
    <div style={style} className={className}>
      {React.createElement(children, rest)}
    </div>
  )
}

const convertEventComponentProps = <TEvent extends AgendaEventModel>(
  props: EventWrapperProps<TEvent> & { children: React.ComponentType<AgendaEventProps<TEvent>> }
) => ({
  ...props,
  style: {
    ...props.style,
    position: 'relative',
    top: `${props.style.top}%`,
    width: `${props.style.width}%`,
    height: `${props.style.height}%`,
    zIndex: 2,
  } as CSSProperties,
})
